import Swal from "sweetalert2";

document.addEventListener("DOMContentLoaded", () => {
  document.body.addEventListener("click", async (e) => {
    const link = e.target.closest(".ujs-link");
    if (!link) return;

    e.preventDefault();

    const url = link.dataset.url;
    const method = link.dataset.method || "GET";
    const callbackUrl = link.dataset.callbackUrl;
    const confirmMsg = link.dataset.confirm || "Are you sure?";

    // Grab CSRF token
    const token = document.querySelector('meta[name="csrf-token"]')?.content;

    // Step 1: Confirmation
    const result = await Swal.fire({
      title: "Confirm Action",
      text: confirmMsg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, proceed",
      cancelButtonText: "Cancel"
    });

    if (!result.isConfirmed) return;

    // Step 2: Show processing
    Swal.fire({
      title: "Processing...",
      text: "Please wait while we complete your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const response = await fetch(url, {
        method: method.toUpperCase(),
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": token
        },
        credentials: "same-origin"
      });

      if (!response.ok) throw new Error(`Request failed: ${response.status}`);

      const data = await response.json();

      // Step 3: Success alert
      Swal.fire({
        icon: "success",
        title: "Success",
        text: data.message || "Action completed successfully!"
      }).then(() => {
        if (callbackUrl) {
          window.location.href = callbackUrl;
        } else {
          window.location.reload();
        }
      });

    } catch (err) {
      // Step 4: Error alert
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again."
      });
      console.error("AJAX error:", err);
    }
  });
});
